<template>
  <div class="container-fluid">
    <!-- Bread-crumb-->
    <div class="block-header">
      <bread-crumb></bread-crumb>
    </div>
    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card card-top-line">
          <!-- Header -->
          <div class="header d-flex justify-content-between align-items-center">
            <h2>Coupon Code List</h2>
          </div>
          <!-- Coupon Listing-->
          <div class="body pt-0">
            <div
              class="chart-top-action d-lg-flex justify-content-between py-3"
            >
              <div class="d-md-flex justify-content-between">
                <div class="mr-0 mr-md-3 action-top-search">
                  <div class="input-group">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Search partner"
                      aria-label="Search partner"
                      aria-describedby="search-partner"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text" id="search-mail">
                        <i class="icon-magnifier"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="d-md-flex justify-content-between mt-lg-0 mt-md-3 mt-0"
              >
                <div
                  class="payment-dropdown d-flex flex-row-reverse ml-lg-3 mt-3 mt-sm-0"
                >
                  <b-button
                    size="lg"
                    variant="primary btn-mw"
                    @click="addCoupon()"
                  >
                    Add New
                    <i class="fa fa-plus-square"></i>
                  </b-button>
                </div>
              </div>
            </div>
            <!-- Table Pagination -->
            <div
              class="py-1 align-items-center justify-content-end table-pagination"
            >
              <div class="number-page">
                <b-pagination
                  class="pagination-small"
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
            </div>
            <!-- All Coupon List -->
            <b-table
              responsive
              ref="customerTable"
              table-class="mb-0 table-custom border"
              head-variant="light"
              :items="items"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              striped
            >
              <template #head()="{ label, field: { key } }">
                {{ label }}
                <!-- Custom icons -->
                <template>
                  <i v-if="sortBy !== key" class=""></i>
                  <i
                    v-else-if="sortDesc"
                    class="fa fa-long-arrow-down ml-1"
                  ></i>
                  <i v-else class="fa fa-long-arrow-up ml-1"></i>
                </template>
              </template>
              <template #cell(status)="data">
                <p class="function-badge badge-group-table mb-0">
                  <span class="badge ml-0" :class="data.value.class">
                    {{ data.value.name }}
                  </span>
                </p>
              </template>
              <template #cell(action)>
                <b-dropdown
                  id="dropdown-1"
                  text="Actions"
                  right
                  variant="outline-primary"
                >
                  <b-dropdown-item @click="editCoupon">Edit</b-dropdown-item>
                  <b-dropdown-item>Active</b-dropdown-item>
                  <b-dropdown-item @click="showAlert">Delete</b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
            <!-- Table Pagination -->
            <div
              class="py-3 d-flex align-items-center justify-content-between table-pagination"
            >
              <div class="per-page">
                <b-form-group
                  label="Per page"
                  label-for="per-page-select"
                  class="mb-0"
                >
                  <b-form-select
                    id="per-page-select"
                    v-model="perPage"
                    :options="pageOptions"
                    size="sm"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="number-page">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
              <div class="go-page">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Go To Page</span>
                  </div>
                  <input
                    type="text"
                    v-model="currentPageJump"
                    class="form-control"
                    value=""
                    @keyup.enter="onEnter"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "@/plugins/sweetalert2";
export default {
  name: "CouponCodeListComponent",
  components: {
    BreadCrumb: () => import("@/components/BreadCrumb.vue"),
  },
  methods: {
    addCoupon() {
      this.$router.push({ path: "/coupon-managment/create" });
    },
    editCoupon() {
      this.$router.push({ path: "/coupon-managment/edit" });
    },
    showAlert() {
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary btn-lg my-3",
          cancelButton: "btn btn-outline-secondary btn-lg",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You want to delete this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
        })
        .then((result) => {
          if (result.isConfirmed) {
            swalWithBootstrapButtons.fire(
              "Deleted!",
              "Your file has been deleted.",
              "success",
            );
          }
        });
    },

    onEnter(e) {
      var paginationMenu = Math.ceil(this.totalRows / this.perPage);
      if (e.target.value > 0) {
        if (paginationMenu >= e.target.value) {
          this.currentPage = this.currentPageJump = e.target.value;
        } else {
          this.currentPage = this.currentPageJump = paginationMenu;
        }
      } else {
        this.currentPage = this.currentPageJump = 1;
      }
    },
  },
  data() {
    return {
      items: [
        {
          coupon_code: "WELCOME",
          start_date: "2024-05-16",
          end_date: "2024-05-20",
          frequency: 100,
          status: { name: "Expired", class: "badge-danger" },
          action: "",
        },
        {
          coupon_code: "FREE50",
          start_date: "2024-04-04",
          end_date: "2024-04-10",
          frequency: 50,
          status: { name: "Valid", class: "badge-info" },
          action: "",
        },
        {
          coupon_code: "HELLO150",
          start_date: "2023-11-16",
          end_date: "2023-11-29",
          frequency: 150,
          status: { name: "Valid", class: "badge-info" },
          action: "",
        },
        {
          coupon_code: "WELCOME",
          start_date: "2022-08-15",
          end_date: "2022-08-25",
          frequency: 100,
          status: { name: "Expired", class: "badge-danger" },
          action: "",
        },
        {
          coupon_code: "TRY200",
          start_date: "2022-11-16",
          end_date: "2022-11-16",
          frequency: 100,
          status: { name: "Expired", class: "badge-danger" },
          action: "",
        },
      ],

      fields: [
        {
          key: "coupon_code",
          label: "Coupon Code",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "start_date",
          label: "Start date",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "end_date",
          label: "End date",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "frequency",
          label: "Frequency",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
          thClass: "th_sortfix",
        },
        { key: "action", label: "Action", thClass: "th_sortfix" },
        { sortable: true, sortByFormatted: true, filterByFormatted: true },
      ],

      totalRows: 1,
      currentPage: 1,
      currentPageJump: 1,
      perPage: 50,
      pageOptions: [50, 100, 150, { value: 1000, text: 1000 }],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
    };
  },
  mounted() {
    this.totalRows = this.items.length;
  },
};
</script>
